import { UserSchoolGrade } from "@domain/User";
import { NonEmptyArray } from "@helpers/array.helper";

// export type EducationLevel = "elementary" | "highSchool";
export enum EducationLevel {
  // eslint-disable-next-line no-unused-vars
  ELEMENTARY_3,
  // eslint-disable-next-line no-unused-vars
  ELEMENTARY_4,
  // eslint-disable-next-line no-unused-vars
  ELEMENTARY_5,
  // eslint-disable-next-line no-unused-vars
  ELEMENTARY_6,
  // eslint-disable-next-line no-unused-vars
  HIGH_SCHOOL_1,
  // eslint-disable-next-line no-unused-vars
  HIGH_SCHOOL_2,
  // eslint-disable-next-line no-unused-vars
  HIGH_SCHOOL_3,
  // eslint-disable-next-line no-unused-vars
  HIGH_SCHOOL_4,
  // eslint-disable-next-line no-unused-vars
  HIGH_SCHOOL_5,
}

export type EducationLevelGroupId = "elementary-3-4" | "elementary-5-6" | "highSchool-1-2" | "highSchool-3-5";

export interface EducationLevelGroup {
  readonly id: EducationLevelGroupId;
  readonly name: string;
  readonly educationLevels: NonEmptyArray<EducationLevel>;
  readonly numberOfHomophoneGroups: { min: 1 | 3; max: 3 };
  readonly matchingUserSchoolGrades: NonEmptyArray<UserSchoolGrade>;
}
